import React from 'react';

const Pengangkatan = () => {
  return (
    <h1>Pengangkatan</h1>
  );
};

export default Pengangkatan;





